export const actions = {
    SET_GRID_SIZE: 'SET_GRID_SIZE',
    ADD_FLOOR: 'ADD_FLOOR',
    REMOVE_FLOOR: 'REMOVE_FLOOR',
    UPDATE_ROOM_POSITION: 'UPDATE_ROOM_POSITION',
    ADD_ROOM: 'ADD_ROOM',

}